var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 60,
    viewBox: "0 0 118 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7667_266333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 53.881L18.8076 56.7493L96.2438 53.4907L107 3.28439L104.192 0.416016L16 53.881Z",
    fill: "#803917"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1117 14.4387L16 54.5827L93.0477 51.2813L103.75 0.416016L20.1117 14.4387Z",
    fill: "url(#paint0_linear_7667_266333)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7667_266333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.834 49.933L25.6447 47.8621C26.4826 48.3162 27.3205 48.4797 28.1257 48.4131C28.7569 48.3647 29.0724 48.1527 29.0561 47.8682C29.0017 47.0204 25.6011 47.7894 25.4379 45.2947C25.3182 43.4721 26.6131 42.1703 28.8929 41.9886C29.9647 41.9038 30.9386 42.0673 31.6405 42.4609L30.8897 44.5015C30.2857 44.1442 29.573 44.005 28.8711 44.0655C28.1584 44.12 27.8265 44.4167 27.8428 44.6892C27.8972 45.5732 31.3086 44.7376 31.4664 47.2142C31.5807 49.0065 30.2585 50.3205 28.0115 50.5021C26.722 50.6051 25.5576 50.3508 24.834 49.939V49.933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2331 47.2005C32.2168 46.9219 32.2331 46.6494 32.2603 46.3467L32.7717 41.8659L35.2038 41.6721L34.7032 46.1045C34.676 46.3285 34.6706 46.5223 34.6815 46.6979C34.7304 47.4184 35.1004 47.7333 35.7207 47.6849C36.4225 47.6304 36.7762 47.152 36.9122 45.9289L37.4128 41.4965L39.8068 41.3027L39.2844 45.8986C39.007 48.3449 37.7773 49.7194 35.5629 49.895C33.6042 50.0524 32.3528 48.9988 32.2385 47.1944L32.2331 47.2005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3206 43.3811C47.4512 45.4096 46.1073 46.8931 43.8874 47.0687L42.6415 47.1656L42.4184 49.1638L39.9863 49.3576L40.9113 41.2134L44.116 40.9591C46.0529 40.8016 47.2118 41.7039 47.3206 43.3811ZM44.8722 43.8171C44.8341 43.2419 44.4696 43.0299 43.9146 43.0723L43.0985 43.1389L42.8809 45.0463L43.882 44.9676C44.5512 44.9131 44.9212 44.4892 44.8777 43.8171H44.8722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6245 42.4957L50.5211 43.4524L53.5734 43.2102L53.3503 45.1902L50.2871 45.4324L50.1674 46.5042L53.7856 46.2136L53.5462 48.2844L47.5449 48.7628L48.4699 40.6186L54.3351 40.1523L54.0957 42.2232L50.619 42.5017L50.6245 42.4957Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0628 45.4088L61.4176 47.6553L58.893 47.8551L57.7396 45.9175L57.1411 45.9659L56.9125 48.0126L54.4805 48.2063L55.4054 40.0621L58.6427 39.8018C60.5525 39.6504 61.706 40.5405 61.8148 42.1996C61.9073 43.6347 61.2544 44.7912 60.0628 45.4088ZM58.4088 41.9211L57.5926 41.9877L57.375 43.895L58.3761 43.8163C59.0454 43.7618 59.4153 43.338 59.3718 42.6659C59.3337 42.0906 58.9692 41.8787 58.4142 41.9211H58.4088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.423 45.5292L67.6699 45.7472L67.0388 47.2065L64.4707 47.4124L68.5514 39.0139L70.9453 38.8262L73.1761 46.7221L70.7549 46.9159L70.4285 45.5353L70.423 45.5292ZM69.9551 43.6037L69.4709 41.5752L68.5405 43.7127L69.9551 43.5976V43.6037Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8968 40.7042C81.0274 42.7327 79.6835 44.2162 77.4636 44.3918L76.2176 44.4887L75.9946 46.4869L73.5625 46.6806L74.4874 38.5364L77.6921 38.2821C79.6291 38.1308 80.788 39.0269 80.8968 40.7042ZM78.4484 41.1402C78.4103 40.5649 78.0458 40.353 77.4908 40.3954L76.6747 40.462L76.457 42.3694L77.4582 42.2906C78.1274 42.2361 78.4974 41.8123 78.4538 41.1402H78.4484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4534 40.1046C88.584 42.1331 87.2401 43.6166 85.0202 43.7922L83.7743 43.8891L83.5512 45.8873L81.1191 46.081L82.0441 37.9368L85.2488 37.6825C87.1857 37.5311 88.3446 38.4273 88.4534 40.1046ZM86.0051 40.5406C85.967 39.9653 85.6024 39.7534 85.0475 39.7958L84.2313 39.8624L84.0137 41.7698L85.0148 41.691C85.684 41.6365 86.0486 41.2127 86.0051 40.5406Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_7667_266333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8691 22.0196L38.6535 25.5861C40.4762 26.0887 41.6405 27.4814 41.7657 29.4372C41.9996 33.04 38.8875 35.9465 34.562 36.2916C32.4183 36.4611 30.3235 36.0797 28.6641 35.014L30.7044 30.9207C31.9395 31.6594 33.3759 31.9319 34.6218 31.8289C36.0147 31.72 36.7546 31.1568 36.6948 30.2243C36.6513 29.5583 36.1561 29.2616 35.1278 29.3403L33.0494 29.5038L33.4466 25.9978L35.9004 23.2851L30.5847 23.709L31.0852 19.4038L42.2717 18.5137L41.8745 22.0196H41.8691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6662 21.5115L55.4868 21.13L53.9905 34.3605L49.1699 34.742L50.6662 21.5115ZM50.6281 17.8966C50.5193 16.2254 51.6618 14.869 53.5281 14.7176C55.2202 14.5844 56.3356 15.523 56.428 16.958C56.5423 18.7443 55.3997 20.0825 53.5389 20.2339C51.8468 20.3671 50.726 19.3317 50.6335 17.9026L50.6281 17.8966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9496 24.1937C69.9822 24.6963 69.9713 25.2473 69.906 25.8528L69.0845 33.1553L64.2421 33.5428L64.9984 26.8882C65.0201 26.5976 65.0473 26.3311 65.031 26.095C64.9712 25.1625 64.5305 24.7205 63.7198 24.7871C62.6261 24.8718 61.908 25.7196 61.7175 27.4392L60.983 33.8032L56.1406 34.1907L57.6369 20.9602L62.2018 20.5969L62.0494 21.929C63.007 20.7725 64.2639 20.1973 65.4663 20.1004C67.931 19.9066 69.7646 21.2448 69.955 24.1997L69.9496 24.1937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.9681 14.5L85.042 31.4363L79.982 31.842L81.4075 19.217L78.834 19.4228L79.3345 15.1176L86.9627 14.5121L86.9681 14.5Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.4173 28.582L94.5629 52.7823L65.834 53.9086L96.7646 54.582L99.4173 28.582Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.583 19.916L98.1602 57.3205L50.666 55.2246L100.839 59.9993L101.583 19.916Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7667_266333",
    x: 24.834,
    y: 37.666,
    width: 65.8589,
    height: 14.5294,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.23,
    dy: 1.67
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.627451 0 0 0 0 0.32549 0 0 0 0 0.596078 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7667_266333"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7667_266333",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_7667_266333",
    x: 28.6641,
    y: 14.5,
    width: 62.3047,
    height: 24.8301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.191667 0 0 0 0 0.191667 0 0 0 0 0.191667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7667_266333"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7667_266333",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7667_266333",
    x1: 16,
    y1: 27.4993,
    x2: 103.75,
    y2: 27.4993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD746C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9068"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7667_266333"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 59,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects);
export default __webpack_public_path__ + "static/media/objects.7928534046775dc7f6de5ee617746f3b.svg";
export { ForwardRef as ReactComponent };